module.exports = __webpack_public_path__ + "img/precipitacion_ppt_hover.84777863.png";